var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-col',{attrs:{"vs-type":"flex","vs-align":"flex-end","vs-w":"7"}},[_c('v-select',{staticClass:"sdf-text-16-400-white style-chooser w-full ml-4 mb-8",attrs:{"options":_vm.options,"clearable":false,"searchable":false},model:{value:(_vm.selectedVessel),callback:function ($$v) {_vm.selectedVessel=$$v},expression:"selectedVessel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }